// @ts-nocheck

export default {
  INIT_SUBSCRIPTION_PLANS: 'INIT_SUBSCRIPTION_PLANS',
};